/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import './style.scoped.scss';
import CloseButton from '../../Buttons/CloseButton';
import { emailRegex, notification } from '../../../assets/constants/strings';
import { sendQuote } from '../../../store/User/userActions';
import { SEND_ENQUIRY } from '../../../store/User/userTypes';
import AuthLoader from '../../Loader/Auth';
import PhoneNumberInput from '../../Account/PhoneNumberInput';
import {
  formatPhoneNumberIntl,
  isValidPhoneNumber,
} from 'react-phone-number-input';

const RequestQuoteModal = ({
  user,
  sendQuote,
  handleClose,
  handleDismiss,
  enquiry,
  handleSentSuccess,
  loading,
}) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [organisation, setOrganisation] = useState('');
  const [numberOfUsers, setNumberOfUsers] = useState(11);
  const [jobTitle, setJobTitle] = useState('');
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1000);
  const [isValidPhone, setIsValidPhone] = useState(false);
  const [errorMessage, setErrorMessage] = useState('Not a valid phone number.');
  const [showError, setShowError] = useState(false);

  // using refs to ensure the load logic works
  const screenRef = useRef(isSmallScreen);
  screenRef.current = isSmallScreen;

  useEffect(() => {
    $('#requestQuoteModal').on('hide.bs.modal', () => {
      setShowError(false);
      setFirstName(user && user.firstName ? user.firstName : '');
      setLastName(user && user.lastName ? user.lastName : '');
      setEmail(user && user.email ? user.email : '');
      setOrganisation(user && user.organisation ? user.organisation : '');
      setPhone(user && user.phoneNumber ? user.phoneNumber : '');
      setJobTitle(user && user.jobTitle ? user.jobTitle : '');
      handleDismiss();
    });
  }, []);

  useEffect(() => {
    // listen for changes in window width for hide/show logic
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    if (user) {
      setFirstName(user.firstName ? user.firstName : '');
      setLastName(user.lastName ? user.lastName : '');
      setEmail(user.email ? user.email : '');
      setOrganisation(user.organisation ? user.organisation : '');
      setPhone(user.phoneNumber ? user.phoneNumber : '');
      setJobTitle(user.jobTitle ? user.jobTitle : '');
    }
  }, [user]);

  useEffect(() => {
    if (phone.length > 0) {
      setIsValidPhone(isValidPhoneNumber(phone));
    }
  }, [user, phone]);

  const checkScreenSize = () => {
    screenRef.current = window.innerWidth < 1000;
    setIsSmallScreen(screenRef.current);
  };

  const handleConfirm = async (e) => {
    e.preventDefault();

    if (!emailRegex(email)) {
      notification(
        'danger',
        'Invalid Information.',
        'Please review any fields marked in red.',
        undefined,
        3.5
      );
    } else {
      await sendQuote({
        firstName: firstName,
        lastName: lastName,
        email: email,
        organisation: organisation,
        jobTitle: jobTitle,
        userTier: numberOfUsers,
        phoneNumber: phone,
      });
    }
  };

  const onChangeNumber = (phoneNumber) => {
    const newPhone = phoneNumber;
    if (newPhone === undefined) setIsValidPhone(false);
    else if (newPhone && newPhone.length > 0) {
      if (isValidPhoneNumber(newPhone)) {
        setIsValidPhone(true);
        setPhone(newPhone);
        setShowError(false);
        setErrorMessage('');
      } else {
        setShowError(true);
        setIsValidPhone(false);
        setErrorMessage('Not a valid phone number.');
      }
    } else setErrorMessage('Please enter your phone number.');
  };

  const handleNumber = () => {
    if (phone && phone.length > 0) {
      if (isValidPhone) setShowError(false);
      else setShowError(true);
    }
  };

  useEffect(() => {
    if (enquiry && enquiry.request === SEND_ENQUIRY && enquiry.success === true)
      handleSentSuccess();
  }, [enquiry]);

  return (
    <div
      className='modal request-quote-modal'
      id='requestQuoteModal'
      role='dialog'
      aria-hidden='true'
      data-backdrop='static'
      data-keyboard='false'
    >
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h2 className='modal-title'>Request a Quote</h2>
            <CloseButton title='Dismiss Modal' handleClose={handleClose} />
          </div>
          <div className='modal-body'>
            <form
              onSubmit={handleConfirm}
              className='mt-3 text-center'
              autoComplete='off'
            >
              <div className={isSmallScreen ? 'inputsColumn' : 'inputsRow'}>
                <div className='form-group mb-3'>
                  <input
                    className='form-control'
                    placeholder='First Name'
                    id='FirstName'
                    onChange={(e) => setFirstName(e.target.value)}
                    value={firstName}
                    maxLength={35}
                    required
                  />
                </div>
                <div className='form-group mb-3'>
                  <input
                    className='form-control'
                    placeholder='Last Name'
                    id='LastName'
                    onChange={(e) => setLastName(e.target.value)}
                    value={lastName}
                    maxLength={35}
                    required
                  />
                </div>
              </div>
              <div className={isSmallScreen ? 'inputsColumn' : 'inputsRow'}>
                <div className='form-group mb-3'>
                  <input
                    className={`form-control${
                      email.length === 0
                        ? ''
                        : emailRegex(email)
                        ? ' is-valid'
                        : ' is-invalid'
                    }`}
                    placeholder='Email'
                    type='email'
                    id='Email'
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    maxLength={320}
                    required
                  />
                </div>
                <div className='form-group mb-3'>
                  <input
                    className='form-control'
                    placeholder='Company Name'
                    id='CompanyName'
                    type='text'
                    onChange={(e) => setOrganisation(e.target.value)}
                    value={organisation}
                    required={true}
                  />
                </div>
              </div>
              <div className={isSmallScreen ? 'inputsColumn' : 'inputsRow'}>
                <div className='form-group mb-3'>
                  <input
                    className='form-control'
                    placeholder='Job Title (Optional)'
                    id='JobTitle'
                    onChange={(e) => setJobTitle(e.target.value)}
                    value={jobTitle}
                    maxLength={35}
                  />
                </div>
                <div className='form-group mb-3'>
                  <PhoneNumberInput
                    phoneValue={formatPhoneNumberIntl(phone)}
                    onChangeNumber={(phoneNumber) =>
                      onChangeNumber(phoneNumber)
                    }
                    showError={showError}
                    handleNumberBlur={handleNumber}
                    handleNumberFocus={() => setShowError(false)}
                    errorMessage={errorMessage}
                  />
                </div>
              </div>
              <div className={isSmallScreen ? 'inputsColumn' : 'inputsRow'}>
                <div className='form-group mb-3'>
                  <label className='d-flex'>Number of Users</label>
                  <input
                    className='form-control'
                    placeholder='Number of Users'
                    id='Users'
                    type='number'
                    onChange={(e) => setNumberOfUsers(e.target.value)}
                    value={numberOfUsers}
                    required={true}
                    min={11}
                    max={1000}
                  />
                </div>
              </div>
              <button
                type='submit'
                disabled={
                  numberOfUsers < 11 ||
                  numberOfUsers > 1000 ||
                  loading ||
                  (phone && phone.length > 0 && !isValidPhone) ||
                  phone === ''
                }
              >
                {loading ? 'Sending' : 'Request a Quote'}
                {loading ? <AuthLoader /> : null}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  enquiry: state.user.enquiry,
  loading: state.user.loading,
});

const mapDispatchToProps = { sendQuote };

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(RequestQuoteModal);
